// <head> metadata for OpnPledgePage (https://www.dbos.dev/opn-pledge).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Open Patent Non-Assertion Pledge',
    },
    {
      name: 'description',
      content: 'DBOS Open Patent Non-Assertion Pledge',
    },
    {
      property: 'og:title',
      content: 'Open Patent Non-Assertion Pledge',
    },
    {
      property: 'og:description',
      content: 'DBOS Open Patent Non-Assertion Pledge',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Open Patent Non-Assertion Pledge',
    },
    {
      name: 'twitter:description',
      content: 'DBOS Open Patent Non-Assertion Pledge',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/opn-pledge',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
